import SettingAPI from 'js/api/setting'

export default {
    /** 郵便番号CSVインポート **/

    importPostalCsv ({commit}, data) {
        commit('setImportPostalCsvStatus', 1)

        SettingAPI.importPostalCsv(data)
            .then(resp => {
                commit('setImportPostalCsvStatus', 2)
            })
            .catch(err => {
                commit('setImportPostalCsvStatus', 3)
            })
    },
    /** システムメール送信情報取得**/

    loadSysMailInfo ({commit}) {
        commit('setSysMailInfoLoadStatus', 1)

        SettingAPI.loadSysMailInfo()
            .then(resp => {
                commit('setSysMailInfo', resp)
                commit('setSysMailInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setSysMailInfo', {})
                commit('setSysMailInfoLoadStatus', 3)
            })
    },

    /** システムメールグループ名・ステータス修正　**/
    mailGroupEditSave ({commit}, data) {
        commit('setMailGroupEditSaveStatus', 1)

        SettingAPI.mailGroupEditSave(data)
            .then(resp => {
                commit('updateMailGroupEdit', data)
                commit('setMailGroupEditSaveStatus', 2)
            })
            .catch(err => {
                commit('setMailGroupEditSaveStatus', 3)
            })
    },

    /** システムメールグループ削除　**/

    mailGroupEditDel ({commit}, data) {
        commit('setMailGroupEditDelStatus', 1)

        SettingAPI.mailGroupEditDel(data)
            .then(resp => {
                commit('setMailGroupEditDelStatus', 2)
            })
            .catch(err => {
                commit('setMailGroupEditDelStatus', 3)
            })
    },


    /** システムメール送信グループ**/

    loadMailGroupMember ({commit}, data) {
        commit('setMailGroupMemberLoadStatus', 1)

        SettingAPI.loadMailGroupMember(data)
            .then(resp => {
                commit('setMailGroupMember', resp)
                commit('setMailGroupMemberLoadStatus', 2)
            })
            .catch(err => {
                commit('setMailGroupMember', {})
                commit('setMailGroupMemberLoadStatus', 3)
            })
    },

    setMailGroupMemberSelected ({commit}, data) {
        commit('setMailGroupMemberSelected', data)
    },
    resetMailGroupMember ({commit}) {
        commit('resetMailGroupMember')
    },
    resetMailGroupMemberSelected ({commit} ) {
        commit('resetMailGroupMemberSelected')
    },

    /** メンバーグループ変更(メンバー詳細画面)　**/
    changeMailGroup ({commit}, data) {
        commit('setChangeMailGroupStatus', 1)

        SettingAPI.changeMailGroup(data)
            .then(resp => {
                commit('updateMailGroupList', resp.data)
                commit('updateMailGroupMemberToSelectList', resp.data)
                commit('updateMailGroupMemberToList', resp.data)

                commit('setChangeMailGroupStatus', 2)
            })
            .catch(err => {
                commit('setChangeMailGroupStatus', 3)
            })
    },


    /** システムメールテンプレート保存　**/

    mailTempSave ({commit}, data) {
        commit('setMailTempSaveStatus', 1)

        SettingAPI.mailTempSave(data)
            .then(resp => {
                commit('setMailTempSave', resp.data)
                commit('updateMailTempList', resp.data)
                commit('setMailTempSaveStatus', 2)
            })
            .catch(err => {
                commit('setMailTempSave', {})
                commit('setMailTempSaveStatus', 3)
            })
    },

    /** システムメールテンプレート削除　**/

    mailTempDel ({commit}, data) {
        commit('setMailTempDelStatus', 1)

        SettingAPI.mailTempDel(data)
            .then(resp => {
                commit('delMailTempFromList', data)
                commit('setMailTempDelStatus', 2)
            })
            .catch(err => {
                commit('setMailTempDelStatus', 3)
            })
    },

    /** システムメール送信　**/

    sysMailSend ({commit}, data) {
        commit('setSysMailSendStatus', 1)

        SettingAPI.sysMailSend(data)
            .then(resp => {
                commit('setSysMailSendCnt', resp.data)
                commit('setSysMailSendStatus', 2)
            })
            .catch(err => {
                commit('setSysMailSendStatus', 3)
            })
    },
}
